export const PLATFORM_START_I18N_ENTRIES = {
  platform_start_Data1: {
    es: '<p>Obtén <span class="i18n-bold">inventarios completos</span> de los <span>elementos</span> de la carretera</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
